// If you give me any of this Juri-my-diction crap...
import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {field} from "../../stem-core/state/StoreField";
import {Currency} from "../../stem-core/localization/CurrencyStore";


@globalStore
export class Jurisdiction extends BaseStore("Jurisdiction") {
    @field(String) countryCode: string;
    @field(String) name: string;
    @field("Currency") defaultCurrency: Currency;

    toString(): string {
        return this.name;
    }
}
